// Copyright (c) 2019 Deere & Company

import './labeled-smart-form-link.scss';
import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import SmartFormLink from '../smart-form-link/smart-form-link';

const composeClasses = className => className ?
    `labeled-link ${className}` :
    'labeled-link';

const LabeledSmartFormLink = props =>

    <div className={composeClasses(props.className)}>
        <span className='data-label'>
            <FormattedMessage id={props.label}/>
        </span>
        <span className='data-key'>
            <SmartFormLink
                displayText={props.displayText}
                formName={props.formName}
                objectId={props.objectId}
                translate={props.translateLink}
            />
        </span>
    </div>;

LabeledSmartFormLink.displayName = 'LabeledSmartFormLink';
LabeledSmartFormLink.propTypes = {
    className: PropTypes.string,
    displayText: PropTypes.string.isRequired,
    formName: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    objectId: PropTypes.string.isRequired,
    translateLink: PropTypes.bool
};
LabeledSmartFormLink.defaultProps = {
    translateLink: false
};
export default LabeledSmartFormLink;



// WEBPACK FOOTER //
// ./src/shared/components/labeled-smart-form-link/labeled-smart-form-link.js